<div class="row">
  <div class="col">
    <div class="container-fluid pl-0 info-list has-info-icon height-unset">
      <h3 class="sub-title" id="brand-safety-risk-description">
        Description Risk
        <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip title="The overall Brand Safety risk to advertisers based on textual analysis of the app's descriptive text.
           App descriptive text is processed through natural language algorithms and comprehensive categorical dictionaries
           to predict the advertiser brand safety risk.">
          <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
        </a>
      </h3>
    </div>
  </div>
</div>
<div class="row">
  <div class='col-lg-6 info-row'>
    <div class="info-column">
      <div class="info-section">
        <div class="info-list-2">
          <info-list-item label='Advisories'
            labelTooltip="The risk to brand safety derived from the app's content advisories">
            <risk-heat-meter #value [risk]='data?.descriptionBrandSafety?.advisoriesRisk'></risk-heat-meter>
          </info-list-item>
          <info-list-item label='Adult Content'
            labelTooltip='The risk to brand safety from Adult themed content based on textual analysis of the app and its descriptive content'>
            <risk-heat-meter #value [risk]='data?.descriptionBrandSafety?.adultContentRisk'></risk-heat-meter>
          </info-list-item>
          <info-list-item label='Drug Content'
            labelTooltip='The risk to brand safety from Drug themed content based on textual analysis of the app and its descriptive content'>
            <risk-heat-meter #value [risk]='data?.descriptionBrandSafety?.drugContentRisk'></risk-heat-meter>
          </info-list-item>
        </div>
      </div>
    </div>
  </div>
  <div class='col-lg-6 info-row'>
    <div class="info-column">
      <div class="info-section">
        <div class="info-list-2">
          <div class="divider d-lg-none"></div>
          <info-list-item label='Alcohol Content'
            labelTooltip='The risk to brand safety from Alcohol themed content based on textual analysis of the app and its descriptive content'>
            <risk-heat-meter #value [risk]='data?.descriptionBrandSafety?.alcoholContentRisk'></risk-heat-meter>
          </info-list-item>
          <info-list-item label='Hate Speech'
            labelTooltip='The risk to brand safety from Hate Speech content based on textual analysis of the app and its descriptive content'>
            <risk-heat-meter #value [risk]='data?.descriptionBrandSafety?.hateSpeechRisk'></risk-heat-meter>
          </info-list-item>
          <info-list-item label='Offensive Content'
            labelTooltip='The risk to brand safety from content with Offensive Language based on textual analysis of the app and its descriptive content'>
            <risk-heat-meter #value [risk]='data?.descriptionBrandSafety?.offensiveContentRisk'></risk-heat-meter>
          </info-list-item>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-container
  *ngIf="isFreemium || data?.contentBrandSafety?.imageData?.length > 0 && data?.contentBrandSafety?.imageData[0]?.url !== 'null'">
  <div class="row">
    <div class="col">
      <div class="container-fluid pl-0 info-list has-info-icon height-unset mt-32px">
        <h3 class="sub-title" id="brand-safety-risk-content">
          Content Risk
          <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip title="The overall Brand Safety risk to advertisers based on computer vision driven image analysis as well as
          textual analysis of language extracted from images of the app's content.  In-App visual content is processed
          through an advanced machine learning algorithm and evaluated for risk to advertiser brand safety.">
            <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
          </a>
        </h3>
      </div>
    </div>
  </div>
  <div class="row">
    <div class='col-lg-6 info-row'>
      <div class="info-column">
        <div class="info-section">
          <div class="info-list-2">
            <info-list-item label='Adult Content'
              labelTooltip='The risk to brand safety from potential adult images and content detected within the app.'>
              <risk-heat-meter #value [risk]='data?.contentBrandSafety?.adultContentRisk'></risk-heat-meter>
            </info-list-item>
          </div>
        </div>
      </div>
    </div>
    <div class='col-lg-6 info-row'>
      <div class="info-column">
        <div class="info-section">
          <div class="info-list-2">
            <div class="divider d-lg-none"></div>
            <info-list-item label='Violence Content'
              labelTooltip='The risk to brand safety from potential violent imagery and content detected within the app.'>
              <risk-heat-meter #value [risk]='data?.contentBrandSafety?.violenceContentRisk'></risk-heat-meter>
            </info-list-item>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class='col' *ngIf="!isFreemium">
      <div class='image-data-grid'>
        <ng-container *ngFor='let imageData of data?.contentBrandSafety?.imageData; let i = index'>
          <div class='image-data-cont' [ngClass]="{open:currentOpenImageUrl === imageData.url}"
            (click)="toggleAccordion(imageData)">
            <div class="d-flex flex-wrap justify-content-between">
              <div class="image-cont">
                <img class="image" [attr.src]="imageData.url | screenshot:os:278" alt="Image Data" />
              </div>
              <div class="info-cont">
                <div class="d-flex justify-content-between" [ngClass]="{'flex-column' : !imageData.isOpen}">
                  <div>
                    <div class="d-flex info-list-item pt-8px">
                      <div class="label">
                        <a class="btn btn-link help-icon p-0" data-placement="top" data-animation="false"
                          data-toggle="tooltip" enTooltip
                          title="The risk to brand safety from potential adult images and content detected within the app.">
                          <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
                        </a> Adult Content
                      </div>
                      <div class="value">
                        <risk-heat-meter [risk]='imageData?.adultRating'></risk-heat-meter>
                      </div>
                    </div>
                    <div class="divider"></div>
                    <div class="d-flex info-list-item">
                      <div class="label">
                        <a class="btn btn-link help-icon p-0" data-placement="top" data-animation="false"
                          data-toggle="tooltip" enTooltip
                          title="The risk to brand safety from potential violent imagery and content detected within the app.">
                          <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
                        </a> Violence Content
                      </div>
                      <div class="value text-capitalize">
                        <risk-heat-meter [risk]='imageData?.violenceRating'></risk-heat-meter>
                      </div>
                    </div>
                    <ng-container *ngIf="imageData.isOpen && imageData?.labels?.length > 0">
                      <div class="scores-list">
                        <div class="d-flex list-item subheading">
                          <div class="label">Label</div>
                          <div class="score">Score</div>
                        </div>
                        <ng-container *ngFor="let label of imageData?.labels">
                          <div class="d-flex list-item">
                            <div class="label">{{label.label}}</div>
                            <div class="score">{{label.score}}</div>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                  </div>
                  <div class="text-extraction-cont">
                    <h3 class="sub-title-2">
                      Image Text Extraction
                      <a class="btn btn-link help-icon p-0" data-placement="top" data-animation="false"
                        data-toggle="tooltip" enTooltip title="Images are processed to detect text components which are displayed here along with
                    descriptive labels and probabilities.">
                        <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
                      </a>
                    </h3>
                    <div class="text-extraction" ps-scrollbar [isOpen]="currentOpenImageUrl === imageData.url">
                      <pre>
                      {{imageData.text.trim()}}
                    </pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
